import { contractTemplateFormToQuery as formToQuery  } from './contractTemplateFormToQuery';
import { contractTemplateQueryToForm as queryToForm } from './contractTemplateQueryToForm';

export default { formToQuery, queryToForm };